<div class="confirmation-wrapper">
  <div class="left">
    <img
      class="confirmation-image"
      alt="confirmation-image"
      src="assets/images/registration/registration-rocket.svg"
    />
  </div>
  <div class="confirmation-content">
    <p class="confirmation-message markant-h2"></p>
    <p class="file-explanation">
      {{ 'booking.confirmation.checkMessage' | transloco }}<br />
    </p>
    <p class="file-explanation">
      {{ 'booking.confirmation.infoMessage' | transloco }}<br />
    </p>
  </div>
</div>
<div class="button-container flex-row-centered">
  <markant-button
    [routerLink]="getEntryLocation()"
    class="close-button"
    colorScheme="primary"
  >
    <span class="next-text">{{
      'booking.confirmation.close' | transloco
    }}</span>
  </markant-button>
</div>
